async function readError(res: Response): Promise<string> {
  const fallback = res.statusText || 'Request failed'
  try {
    const text = await res.text()
    if (!text) return fallback
    try {
      const data = JSON.parse(text)
      const detail = (data as any)?.detail
      if (typeof detail === 'string' && detail.trim()) return detail.trim()
    } catch {
      // plain text body
    }
    return text.trim() || fallback
  } catch {
    return fallback
  }
}

export async function apiGet(path: string) {
  const res = await fetch(path, { credentials: 'include' })
  if (!res.ok) throw new Error(await readError(res))
  return res.json()
}

export async function apiPost(path: string, body: any) {
  const res = await fetch(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body)
  })
  if (!res.ok) throw new Error(await readError(res))
  return res.json()
}

export async function apiPut(path: string, body: any) {
  const res = await fetch(path, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body)
  })
  if (!res.ok) throw new Error(await readError(res))
  return res.json()
}

